<template>
  <basic-container>
    <div class="search_group">
      <el-date-picker v-model="searchTime" size="small" value-format="yyyy-MM-dd" type="daterange" start-placeholder="申请开始时间" end-placeholder="申请结束时间"></el-date-picker>
      <el-select @change="searchAct" v-model="titleType" size="small" clearable placeholder="抬头类型">
        <el-option label="企业单位" :value="1"></el-option>
        <el-option label="个人/非企业单位" :value="2"></el-option>
      </el-select>
      <el-select @change="searchAct" v-model="searchStatus" size="small" clearable placeholder="开票状态">
        <el-option label="待开票" :value="1"></el-option>
        <el-option label="已开票" :value="2"></el-option>
        <el-option label="开票失败" :value="3"></el-option>
      </el-select>
      <el-input :maxlength="30" v-model="userAccount" size="small" placeholder="账号"></el-input>
      <el-input :maxlength="30" v-model="deptName" size="small" placeholder="企业名称"></el-input>
      <el-input :maxlength="30" v-model="email" size="small" placeholder="邮箱地址"></el-input>
      <el-button @click="searchAct" icon="el-icon-search" size="small" type="primary">搜索</el-button>
      <el-button @click="exportList" v-auth="'memberInvoice_export'" icon="el-icon-download" size="small" type="primary">导出</el-button>
    </div>
    <el-table :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}" :max-height="tableHeight"
      v-loading="listLoading" element-loading-text="加载中" border :data="tableData">
      <el-table-column fixed prop="id" label="ID" width="200"></el-table-column>
      <el-table-column fixed prop="userAccount" label="申请账号" width="120"></el-table-column>
      <el-table-column prop="deptName" label="企业名称" width="120"></el-table-column>
      <el-table-column prop="invoiceAmount" label="开票金额（元）" width="120"></el-table-column>
      <el-table-column width="350" label="关联订单">
        <template slot-scope="scope">
          <p v-for="(val,idx) in scope.row.orderDesc" :key="idx">{{val}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="申请时间" width="180"></el-table-column>
      <el-table-column label="抬头类型" width="130">
        <template slot-scope="scope">{{scope.row.type==1?'企业单位':scope.row.type==2?'个人/非企业单位':''}}</template>
      </el-table-column>
      <el-table-column prop="title" label="公司名称" width="120"></el-table-column>
      <el-table-column prop="registerNo" label="公司税号" width="140"></el-table-column>
      <el-table-column prop="title" label="姓名" width="120"></el-table-column>
      <el-table-column prop="email" label="邮箱地址" width="200"></el-table-column>
      <el-table-column label="开票状态">
        <template slot-scope="scope">
          {{scope.row.status==1?'待开票':scope.row.status==2?'已开票':scope.row.status==3?'开票失败':''}}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="reason" label="失败原因"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="180"></el-table-column>
      <el-table-column prop="updateUser" label="修改人" width="200"></el-table-column>
      <el-table-column fixed="right" width="150" label="操作">
        <template slot-scope="scope">
          <el-button @click="openEdit(scope.row)" v-if="scope.row.status==1" v-auth="'memberInvoice_change'" icon="el-icon-info" size="mini" type="text">修改</el-button>
          <el-button @click="checkDetail(scope.row)" v-auth="'memberInvoice_detail'" icon="el-icon-info" size="mini" type="text">订单明细</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table_pagination">
      <el-pagination class="app-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize" :layout="paginationLayout" :total="totalEl">
      </el-pagination>
    </div>
    <el-dialog title="修改" :visible.sync="showEdit" append-to-body width="40%">
      <el-form ref="ruleForm" :model="checkItem" :rules="rules" label-width="80px">
        <el-form-item label="企业名称">{{checkItem.deptName}}</el-form-item>
        <el-form-item label="开票金额">{{checkItem.invoiceAmount}}</el-form-item>
        <el-form-item label="申请时间">{{checkItem.createTime}}</el-form-item>
        <el-form-item label="开票状态" prop="status">
          <el-select v-model="checkItem.status" size="small" placeholder="请选择开票状态">
            <el-option label="已开票" :value="2"></el-option>
            <el-option label="开票失败" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="失败原因" v-if="checkItem.status==3" prop="reason">
          <el-input type="textarea" :rows="3" :maxlength="150" resize="none" v-model="checkItem.reason" placeholder="请输入失败原因"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitChange('ruleForm')" v-auth="'memberInvoice_change'" size="small" type="primary" icon="el-icon-circle-check">保存</el-button>
        <el-button @click="showEdit=false" size="small" icon="el-icon-circle-close">取消</el-button>
      </div>
    </el-dialog>
  </basic-container>
</template>
<script>
import { invoiceList, invoiceSubmit } from '@/api/member'
import { exportInvoice } from '@/services'
import { debounce, deepCopy } from '@/util/common'
import pagination from '@/util/mixins/pagination'
export default {
  mixins: [pagination],
  data () {
    return {
      searchTime: '', // 时间
      titleType: '', // 抬头类型
      searchStatus: '', // 开票状态
      userAccount: '', // 账号
      deptName: '', // 企业名称
      email: '', // 邮箱地址
      rules: {
        status: [{ required: true, message: '请选择开票状态', trigger: 'change' }],
        reason: [{ required: true, message: '请输入失败原因', trigger: 'blur' }]
      },
      checkItem: {}, // 修改项
      showEdit: false // 修改弹窗
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 订单明细
    checkDetail (item) {
      this.$store.dispatch('app/setOrder', item.orderId)
      this.$router.push('/member/order')
    },
    // 打开编辑
    openEdit (item) {
      this.checkItem = deepCopy(item)
      this.checkItem.status = ''
      this.checkItem.reason = ''
      this.showEdit = true
    },
    // 获取列表
    getList () {
      this.listLoading = true
      let postData = {
        createDateBegin: this.searchTime ? this.searchTime[0] : '',
        createDateEnd: this.searchTime ? this.searchTime[1] : '',
        type: this.titleType,
        status: this.searchStatus,
        deptName: this.deptName.trim(),
        email: this.email.trim(),
        userAccount: this.userAccount.trim(),
        current: this.pageNo,
        size: this.pageSize
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.records
          this.totalEl = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      }
      invoiceList(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 提交修改
    submitChange: debounce(function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          invoiceSubmit({
            bizRefrenceId: this.checkItem.id,
            status: this.checkItem.status,
            content: this.checkItem.reason
          }).then(res => {
            if (res.data.code === 200) {
              this.showEdit = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          return false
        }
      })
    }, 300, false),
    // 导出
    exportList () {
      let postData = {
        createDateBegin: this.searchTime ? this.searchTime[0] : '',
        createDateEnd: this.searchTime ? this.searchTime[1] : '',
        type: this.titleType,
        status: this.searchStatus,
        deptName: this.deptName.trim(),
        email: this.email.trim(),
        userAccount: this.userAccount.trim()
      }
      exportInvoice(postData)
    }
  }
}
</script>
